import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import * as firebase from 'firebase'

import { DataLoader } from '@fibo-app/fibo-collab-shared'

class FirebaseCalendarDays extends React.Component {

  calendarDayLoaders : { [string]: DataLoader }

  static propTypes = {
    calendarDays: PropTypes.object,
    dispatch: PropTypes.func.isRequired
  }

  constructor(props : Object) {
    super(props)
    this.calendarDayLoaders = {}
    this.calendarDayDispPropsLoaders = {}
    this.checkCalendars(undefined, props.calendarDays)
  }

  componentWillReceiveProps(nextProps) {
    this.checkCalendars(this.props.calendarDays, nextProps.calendarDays)
  }

  checkCalendars(currCalendarDays, nextCalendarDays) {
    const oldCalendarDays = []
    const newCalendarDays = []
    // Detect the changes (new & old rooms)
    for (const combinedId in nextCalendarDays) {
      if (!currCalendarDays.hasOwnProperty[combinedId]) {
        newCalendarDays.push(nextCalendarDays[combinedId])
      }
    }
    for (const combinedId in currCalendarDays) {
      if (!nextCalendarDays.hasOwnProperty[combinedId]) {
        oldCalendarDays.push(currCalendarDays[combinedId])
      }
    }
    // Start syncing new calendarDays and stop syncing old calendarDays
    for (let i = 0; i < oldCalendarDays.length; i++) {
      this.stopSyncingCalendarDay(oldCalendarDays[i])
    }
    for (let i = 0; i < newCalendarDays.length; i++) {
      this.startSyncingCalendarDay(newCalendarDays[i])
    }
  }

  startSyncingCalendarDay(calendarDay) {
    const combinedId = `${calendarDay.calendarId}->${calendarDay.dateStr}`
    // Sync instances
    const calendarDayLoader = new DataLoader(firebase, 'calendars', `instances/${calendarDay.dateStr}`, true)
    this.props.dispatch(calendarDayLoader.startSyncing(calendarDay.calendarId))
    this.calendarDayLoaders[combinedId] = calendarDayLoader
    // Sync display props
    const calendarDayDispProps = new DataLoader(firebase, 'calendars', `dispProps/${calendarDay.dateStr}`)
    this.props.dispatch(calendarDayDispProps.startSyncing(calendarDay.calendarId))
    this.calendarDayDispPropsLoaders[combinedId] = calendarDayDispProps
  }

  stopSyncingCalendarDay(calendarDay) {
    const combinedId = `${calendarDay.calendarId}->${calendarDay.dateStr}`
    if (this.calendarDayLoaders.hasOwnProperty(combinedId)) {
      this.calendarDayLoaders[combinedId].stopSyncing()
      delete this.calendarDayLoaders[combinedId]
    }
    if (this.calendarDayDispPropsLoaders.hasOwnProperty(combinedId)) {
      this.calendarDayDispPropsLoaders[combinedId].stopSyncing()
      delete this.calendarDayDispPropsLoaders[combinedId]
    }
  }

  render() {
    return null
  }

}

function mapStateToProps(state) {
  return {
    calendarDays: state.firebase.calendarDays
  }
}

export default connect(mapStateToProps)(FirebaseCalendarDays)



// WEBPACK FOOTER //
// ./src/infra/components/FirebaseCalendarDays.js